/* global Videos */
var MobileHomepage = function() {
    var hash_recompute = function(view, mid = MobileHomepage.openmatch) {
        // changing the hash in bellow lines will trigger the popstate event
        // resulting in a parse_hash() call
        // so block unwanted parsing of the url hash by parse_hash() until we are done
        MobileHomepage.BLOCK_PARSE_HASH = true;
        if (view) {
            MatchesTable.match_filter = view;
        }
        MobileHomepage.openmatch = mid;
        var hash = MatchesTable.match_filter + (MobileHomepage.openmatch ? ('_' + MobileHomepage.openmatch) : '');
        if (window.history.state &&
            window.history.state.match &&
            !MobileHomepage.openmatch) {
            // window.history.back() is async and the only way to await for completion
            // is using an one-off on popstate event listener
            // https://developer.mozilla.org/en-US/docs/Web/API/History/back
            window.addEventListener('popstate', () => MobileHomepage.BLOCK_PARSE_HASH = false, {once: true});
            window.history.back();
        } else if ((!window.history.state || !window.history.state.match) &&
                   MobileHomepage.openmatch) {
            window.history.pushState(
                {view: MatchesTable.match_filter, match: MobileHomepage.openmatch},
                null, '#' + hash);
            MobileHomepage.BLOCK_PARSE_HASH = false;
        } else {
            window.history.replaceState(
                {view: MatchesTable.match_filter, match: MobileHomepage.openmatch},
                null, '#' + hash);
            MobileHomepage.BLOCK_PARSE_HASH = false;
        }
        return hash;
    };

    var parse_hash = function() {
        if (MobileHomepage.BLOCK_PARSE_HASH) {
            return;
        }
        var parts = window.location.hash.substr(1).split('_');
        if (parts.length > 0 &&
            parts[0] in {'all': 1, 'fav': 1, 'live': 1, 'fin': 1, 'sched': 1}) {
            MatchesTable.match_filter = parts[0];
            MatchesTable.applyAllFilters();
        }
        if (parts.length > 1 && parseInt(parts[1]) > 0) {
            MobileHomepage.openmatch = parts[1];
            MobileHomepage.tr_click(MobileHomepage.openmatch);
        } else {
            MobileHomepage.closeMatch(false);
            MobileHomepage.openmatch = false;
        }
    };

    return {
        BLOCK_PARSE_HASH: false,

        init: function(date) {
            MobileHomepage.openmatch = false;
            MobileHomepage.date = date;
            MobileHomepage.glomex = false;
            MobileHomepage.firstview = false;
            MobileHomepage.twitter_script_loaded = false;
            MobileHomepage.insta_script_loaded = false;
            parse_hash();
            $(document).on('click', 'tr.ii__match_row', function(e){
                if ($(this).data('mid')) {
                    e.stopPropagation();
                    e.preventDefault();
                    MobileHomepage.tr_click($(this).data('mid'));
                }
            });
            // filter matches buttons
            $('.ii__mf_btn').click(function() {
                var filter = $(this).data('filter');
                if (filter != undefined) {
                    // run non-critical part in a delayed fashion #INP_optimization
                    setTimeout(() => {
                        hash_recompute(filter);
                    });
                }
            });
            // order by buttons
            $('.ii__om_btn').click(function() {
                var order = $(this).data('orderby');
                if (order != undefined) {
                    MobileHomepage.order_matches(order);
                }
            });
            $('#save_odds_company').change(function() {
                MobileHomepage.saveOddsCompany($(this).val());
            });
            MobileGeneric.initMatchArticleTabTrigger();
            if (Generic.getParam('_update_method') != 'push') {
                setTimeout(MobileHomepage.matchesRefreshLoop, 20 * 1000);
            }
            window.onpopstate = function(event) {
                parse_hash();
            };
            $('.ii__overlay_close').click(function() {
                MobileHomepage.closeMatch();
            });
        },
        closeMatch: function(allowHashRecompute = true) {
            // run critical part ASAP
            Generic.handleOverlay(false);
            // run non-critical part in a delayed fashion #INP_optimization
            setTimeout(function() {
                $('.ii__overlay__content').empty();
                $('.ii__overlay__content').removeClass('ii__matchopen');
                $('#overlay-fav-star').children(':first').removeClass('fas').addClass('fal');
                $('.ii__overlay__content').removeData('mid');
                $('.ii__sticky_footer').show();
                // remove history overlay+content from DOM
                // see MobileGeneric.initMatchHistory() for more info
                $('.ii__history_close').click(); // close history popup
                $('#main_content > .ii__history').remove();
                $('#main_content > .ii__history_overlay').remove();

                MobileGeneric.sticky_footer_visible = true;
                if (allowHashRecompute) {
                    hash_recompute(false, false);
                }
            });
        },
        order_matches: function(ord) {
            if (ord == MatchesTable.byleague) {
                return;
            }
            if (ord == 'bytime') {
                $('.ii__om_time').addClass('active blue');
                $('.ii__om_league').removeClass('active blue');
            } else {
                $('.ii__om_time').removeClass('active blue');
                $('.ii__om_league').addClass('active blue');
            }
            Generic.showProgressLoader();
            MatchesTable.store_match_ordering(ord);
            MobileHomepage.matchesRefresh(true);
        },
        matchesRefresh: function(reloadall = false, scroll_to = '') {
            // refresh open match
            $('.ii__overlay__content.ii__matchopen').each(function(i, e) {
                var mid = $('.ii__overlay__content').data('mid');
                var targetElem = reloadall ? $(e) : $(e).find('.ii__live_part');
                MobileMatch.refresh(mid, reloadall, targetElem);
            });

            var old_scroll = $(document).scrollTop();
            return Ajax.getLive(
                MobileHomepage.date,
                false,
                MatchesTable.byleague,
                (res) => {
                    $('#results').html(res.html);
                    MatchesTable.applyAllFilters();
                    if (scroll_to) {
                        old_scroll = $(scroll_to).offset().top - 70;
                    }
                    $(document).scrollTop(old_scroll);
                    Generic.hideProgressLoader();
                });
        },
        matchesRefreshLoop: function() {
            MobileHomepage.matchesRefresh().finally(function() {
                setTimeout(MobileHomepage.matchesRefreshLoop, 20 * 1000);
            });
        },
        saveOddsCompany: function(odds_company_id, match_id = 0) {
            Generic.showProgressLoader();
            Ajax.savePrefOddsCompany(odds_company_id, () => {
                var scroll_to = false;
                if (match_id > 0) {
                    scroll_to = '#voting' + match_id;
                }
                MobileHomepage.matchesRefresh(true, scroll_to);
            });
        },
        initMatchOverlay: function() {
            $('.ii__matchpage_tab').click(function() {
                if ($('#match-tabs').position().top < 60) {
                    $('.overlay').scrollTop(
                        $('.overlay').scrollTop() + $('#match-tabs').position().top - 60);
                }
                MobileMatch.recordTabClick(this);
            });
        },
        tr_click: function(id) {
            // run critical part ASAP
            const overlay_content_elem = document.getElementById('overlay_content');
            overlay_content_elem.innerHTML = `
                <div style="width:100%; height:100%; text-align:center; display:table; font-size:1.5em; color:#ddd;">
                    <span style="display:table-cell; vertical-align:middle;" class="fa-2x">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </span>
                </div>
            `;
            $('#overlay-title').html('');
            Generic.handleOverlay(true);
            // run non-critical part in a delayed fashion #INP_optimization
            setTimeout(function() {
                overlay_content_elem.dataset.mid = id;
                hash_recompute(false, id);
                $('.ii__sticky_footer').hide();
                MobileGeneric.sticky_footer_visible = false;
                Ajax.getMobileMatchPage(false, id, true, function(res) {
                    if (res.success != 'ok') {
                        return;
                    }
                    $('#overlay-fav-star').data('mid', id);
                    $('#overlay-title').html(res.title);
                    $(overlay_content_elem).html(res.html);
                    overlay_content_elem.classList.add('ii__matchopen');
                    MobileHomepage.initMatchOverlay();
                    MobileGeneric.initMatchHistory(true);
                    Generic.init_popovers();
                    Generic.updateTimes();
                    Vote.init();
                    MatchesTable.applyOverlayFav(id);
                    UserMention.init();
                    if (res.load_firstview) {
                        if (!MobileHomepage.firstview) {
                            Generic.loadScript(
                                'https://t.atmng.io/adweb/NemFRaIXO.prod.js',
                                () => {
                                    // bellow code is standard from firstview
                                    // and the same as in header.php
                                    const n = document;
                                    if (!window.cnx) {
                                        window.cnx = {}, window.cnx.cmd = [];
                                        var t = n.createElement('iframe');
                                        t.src = 'javascript:false';
                                        t.display = 'none';
                                        t.onload = function() {
                                            var n = t.contentWindow.document,
                                                c = n.createElement('script')
                                            ;
                                            c.src = `//cd.connatix.com/connatix.player.js?cid=${Generic.firstview_customer_id}&pid=${Generic.firstview_player_id}`;
                                            c.setAttribute('async','1');
                                            c.setAttribute('type','text/javascript');
                                            n.body.appendChild(c);
                                            // bellow code is ours
                                            Videos.initFirstView();
                                            MobileHomepage.firstview = true;
                                        };
                                        n.head.appendChild(t);
                                    // bellow code is ours
                                    } else {
                                        Videos.initFirstView(); // (make sure firstview handlers are initialized even if the player is already loaded)
                                        MobileHomepage.firstview = true;
                                    }
                                }
                            );
                        } else {
                            Videos.initFirstView();
                        }
                    }
                    if (res.load_twitter_script && !MobileHomepage.twitter_script_loaded) {
                        Generic.loadScript(
                            'https://platform.twitter.com/widgets.js',
                            () => {
                                MobileHomepage.twitter_script_loaded = true;
                            }
                        );
                    }
                    if (res.load_insta_script && !MobileHomepage.insta_script_loaded) {
                        Generic.loadScript(
                            'https://www.instagram.com/embed.js',
                            () => {
                                MobileHomepage.insta_script_loaded = true;
                            }
                        );
                    }
                });
                if (!MobileHomepage.glomex) {
                    Generic.loadScript(
                        'https://player.glomex.com/integration/1/glomex-player.js',
                        () => {
                            MobileHomepage.glomex = true;
                        }
                    );
                }
            });
        }
    };
}();
